module.exports = __webpack_public_path__ + "static/kirana-24d4ff16aecc4dd65e7d83ca2a7459a2.png";